function config($stateProvider) {

	$stateProvider
		.state('server_error', {
			templateUrl: 'states/server_error/server_error.html'
		});
}

config.$inject = ['$stateProvider'];

export default angular.module('server_error', [])
                      .config(config);


// WEBPACK FOOTER //
// ./modules/distribution/states/server_error/server_error.module.js